// @flow
import React from 'react'
type Props = {
  path1Props?: any,
  path2Props?: any,
  svgProps?: any,
}
export default (props: Props) => {
  const path1Props = props.path1Props || {}
  const path2Props = props.path2Props || {}
  const svgProps = props.svgProps || {}
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" {...svgProps}>
      <g fill="none" fillRule="evenodd">
        <path {...path1Props} stroke="#C5CCD4" strokeWidth="2" d="M6.5 1a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11z" />
        <path
          {...path2Props}
          fill="#C5CCD4"
          d="M10.293 10.293a1 1 0 0 1 1.414 0l4.121 4.121a1 1 0 1 1-1.414 1.414l-4.121-4.12a1 1 0 0 1 0-1.415z"
        />
      </g>
    </svg>
  )
}
